import { Text } from '@mantine/core'
import type { SDR } from '@seen/core/models/tasks/sdr/sdr'
import { SDRStatus } from '@seen/core/models/tasks/sdr/utils'
import { now } from '@seen/core/utils'
import { Button } from '@seen/ui'
import { IconArrowRight } from '@tabler/icons-react'
import type { JSX } from 'react'
import { adjustDateForSDRDeadlineAvoidingWeekends } from '#src/components/sdr/create/utils.ts'
import { SDRDisplayForwardBackButtons } from '#src/components/sdr/display/SDRDisplayForwardBackButtons.tsx'
import { SDRTimeRemainingWithTooltip } from '#src/components/sdr/display/SDRTimeRemainingWithTooltip.tsx'
import type { SDRDisplayStep } from '#src/components/sdr/display/utils.ts'
import { useIsReadOnly } from '#src/hooks/useIsReadOnly.ts'
import { usePatchMutation } from '#src/hooks/usePatchMutation.ts'

type Props = {
  sdr: SDR
  selectedStep: SDRDisplayStep
  setSelectedStep: (step: SDRDisplayStep) => void
}

export function SDRAdvanceToInReview({
  sdr,
  selectedStep,
  setSelectedStep,
}: Props): JSX.Element {
  const isReadOnly = useIsReadOnly()
  const sdrStatus = sdr.status

  const advanceMutation = usePatchMutation<SDR>()

  return (
    <div className="flex flex-row items-center justify-between">
      {sdrStatus === SDRStatus.REQUESTED ? (
        <>
          <SDRTimeRemainingWithTooltip sdr={sdr} />
          {advanceMutation.error && (
            <Text className="text-red-600">
              {advanceMutation.error instanceof Error
                ? advanceMutation.error.message
                : String(advanceMutation.error)}
            </Text>
          )}
          <div>
            <Button
              onClick={() => {
                advanceMutation.mutate({
                  instance: sdr,
                  mutateFn: (sdr) => {
                    sdr.state = SDRStatus.IN_REVIEW

                    const reviewDate = now()
                    sdr.decisionNotificationDate =
                      adjustDateForSDRDeadlineAvoidingWeekends(
                        reviewDate,
                        'DecisionNotification'
                      )

                    sdr.reviewDate = reviewDate
                  },
                })
              }}
              loading={advanceMutation.isPending}
              disabled={isReadOnly}
            >
              Move Into Review
              <IconArrowRight className="size-4" />
            </Button>
          </div>
        </>
      ) : (
        <>
          <div />
          <div>
            <SDRDisplayForwardBackButtons
              selectedStep={selectedStep}
              setSelectedStep={setSelectedStep}
            />
          </div>
        </>
      )}
    </div>
  )
}
